export default __webpack_public_path__ + "6e80690466d0fb7655d2994afb2171db.png";